import { IUseTravelerLabel } from '../types'

function pluralize(singularName, pluralName, count, concat) {
  if (!count || count <= 0) return ''

  return `${concat ? ', ' : ''}${count} ${count === 1 ? singularName : pluralName}`
}

/** @public */
function useTravelerLabel({ adults, youths, children, lapInfants, rooms }: IUseTravelerLabel) {
  const adultLabel = pluralize('Adult', 'Adults', adults, false)
  const youthLabel = pluralize('Youth', 'Youths', youths, true)
  const childLabel = pluralize('Child', 'Children', children, true)
  const infantLabel = pluralize('Lap Infant', 'Lap Infants', lapInfants, true)
  const roomLabel = pluralize('Room', 'Rooms', rooms, true)

  let label = adultLabel
  label += youthLabel
  label += childLabel
  label += infantLabel
  label += roomLabel

  const threeTypesOfTraveler =
    (youths > 0 && children > 0) || (youths > 0 && lapInfants > 0) || (children > 0 && lapInfants > 0)

  const passengerCount = adults + youths + children
  const passengerLabel = `${passengerCount} Passengers` + infantLabel + roomLabel

  return threeTypesOfTraveler ? passengerLabel : label
}

export default useTravelerLabel
